import { NgModule } from "@angular/core";
import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  ElementRef,
} from "@angular/core";
import { TamasAlunoService } from "../tamas-aluno.service";
import { Router, ActivatedRoute } from "@angular/router";
import { AlertaConfirmDialog } from "../alerta-confirm";
import { AlertaSimplesDialog } from "../alerta-simples";
import { AlertaSocialMoreDialog } from "../alerta-socialmore";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { Location } from "@angular/common";
import * as moment from "moment";
import { FeedStruct } from "../tamas-models";

@Component({
  selector: "app-me-post",
  templateUrl: "./me-post.component.html",
  styleUrls: ["./me-post.component.css"],
})
export class MePostComponent implements OnInit {
  @ViewChild("inputTxtMsg") inputEl: ElementRef;
  @ViewChild("posicao") posicao: ElementRef;
  hideCL: boolean = false;
  hideAB: boolean = true;
  txtmsg: any = "";
  usuarioPost: any = "";
  idPost: any = 0;
  idComentario: any = 0;
  arrFeedPost: any[] = [];
  feedPost: FeedStruct = new FeedStruct();
  arrReact: any[] = [];
  arrIFollow: any[] = [];
  arrComentarios: any[] = [];
  arrRespostas: any[] = [];
  arrCS: any[] = [];
  arrIE: any[] = [];
  urlFoto: any = "";
  urlFotoFeed: any = "";
  mId: any = 0;
  selfR: boolean = false;
  idR: any = 0;
  datahoje: any = "";
  respCID: any = 0;
  respTag: any = "";
  contadorIndex: any = 0;
  contadorIndexR: any = 0;
  loadMore: boolean = true;
  loadMoreR: boolean = true;
  tabIndex: any = 0;
  constructor(
    public tmaService: TamasAlunoService,
    private _location: Location,
    public router: Router,
    public route: ActivatedRoute,
    public dialog: MatDialog
  ) {}

  ngOnInit() {
    this.usuarioPost = this.route.snapshot.paramMap.get("nickuser");
    this.idPost = this.route.snapshot.paramMap.get("postid");
    this.urlFoto = this.tmaService.urlRepositorioS3 + "/users-profile-picture/";
    this.urlFotoFeed = this.tmaService.urlRepositorioS3 + "/users-feed/";

    //this.hideCL = true;

    this.tmaService.eventoFS(true);
    this.carregarPost();
  }

  ngOnDestroy() {
    this.tmaService.socialTipo = "";
    this.tmaService.eventoFS(false);
  }

  carregarPost(): void {
    this.hideCL = false;
    let customParams = {
      //lista: localStorage.getItem('turboCart'),
      email: this.tmaService.hcEmail,
      senha: this.tmaService.hcSenha,
      idPost: this.idPost,
      usuarioPost: this.usuarioPost,
    };
    this.tmaService.infoPost(customParams).subscribe(
      (qRes) => {
        this.hideCL = true;
        console.log(qRes);
        if (qRes["res"] == "done") {
          this.feedPost = qRes["dadosPost"];
          //this.arrComentarios = qRes['ultComentario'];
          this.renderizarComentarios(qRes["ultComentario"], true);
          //this.arrRespostas = qRes['ultComentario'];
          this.renderizarReacoes(qRes["ultReacao"], qRes["iFollow"]);
          this.mId = qRes["self"];
          this.selfR = qRes["selfR"];
          this.idR = qRes["idreacao"];
          this.datahoje = moment(qRes["dthj"]).format("DD/MM/YYYY HH:mm");
          console.log(this.datahoje);

          if (this.tmaService.socialTipo == "Reagiu") {
            this.tabIndex = 1;
            this.posicao.nativeElement.scrollIntoView({
              behavior: "smooth",
              block: "start",
            });
          }
          if (this.tmaService.socialTipo == "Comentário") {
            this.tabIndex = 0;
            this.posicao.nativeElement.scrollIntoView({
              behavior: "smooth",
              block: "start",
            });
          }
          //console.log(this.arrComentarios['DifDias']);

          //determinar a data a ser exibida
          if (this.feedPost["DifDias"] > 7) {
            var tempoSem = Math.round(this.feedPost["DifDias"] / 7);
            if (tempoSem > 56) {
              var tempoY = Math.round(this.feedPost["DifDias"] / 56);
              this.feedPost["dt"] = tempoY + " a";
              //console.log(qItem.DifDias % 7);
            } else {
              this.feedPost["dt"] = tempoSem + " sem";
              //console.log(qItem.DifDias / 7);
            }
          } else {
            if (this.feedPost["DifDias"] == 0) {
              var a = moment(
                this.feedPost["HoraRegistro"].Hours +
                  ":" +
                  this.feedPost["HoraRegistro"].Minutes,
                "HH:mm:ss"
              );
              var now = moment();
              console.log(now.diff(a, "hours"));
              if (now.diff(a, "hours") > 0) {
                this.feedPost["dt"] = now.diff(a, "hours") + " h";
              } else {
                this.feedPost["dt"] = now.diff(a, "minutes") + " m";
              }
            } else {
              this.feedPost["dt"] = this.feedPost["DifDias"] + " d";
            }
          }

          //this.arrIE = qRes['arrEstatistica'];

          //percorrer array feed
          // this.arrFeedPost.forEach((qItem, index) => {
          //   this.arrFeedPost[index].qtyC = this.arrIE.find(x => x.idpost == qItem.Id).qtycomentarios;
          //   this.arrFeedPost[index].qtyR = qItem.total;
          //   //this.arrFeedPost[index].qtyR = this.arrIE.find(x => x.idpost == qItem.Id).qtyreacoes;
          //   this.arrFeedPost[index].dataform = moment(this.arrFeedPost[index].DataFull).format("DD/MM/YYYY");
          //   this.arrFeedPost[index].horaform =  moment(this.arrFeedPost[index].HoraRegistro.Hours + ':' + this.arrFeedPost[index].HoraRegistro.Minutes,'HH:mm' ).format("HH:mm");
          //   console.log(this.arrFeedPost[index].dataform);
          // });
        } else {
          if (qRes["res"] == "removed") {
            this.router.navigate(["/me/feed"], { replaceUrl: true });
          } else {
            const erroCriar = this.dialog.open(AlertaSimplesDialog, {
              disableClose: true,
              data: {
                tituloAlerta: "Aviso",
                textoAlerta:
                  "Ocorreu um erro ao realizar esta operação Tente novamente",
                iconAlerta: "warning",
              },
            });
          }
        }
      },
      (error) => {
        this.hideCL = true;
        const erroCriar = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: {
            tituloAlerta: "Aviso",
            textoAlerta:
              "Verifique sua conexão com a internet. Tente novamente",
            iconAlerta: "warning",
          },
        });
      }
    );
  }

  renderizarReacoes(lReacoes: any, lFollow: any): void {
    lReacoes.forEach((item) => {
      this.arrReact.push({
        FotoPerfil: item.FotoPerfil,
        Id: item.Id,
        IdAlunoR: item.IdAlunoR,
        IdPost: item.IdPost,
        IdRc: item.IdRc,
        Nome: item.Nome,
        TipoReacao: item.TipoReacao,
        UsuarioNome: item.UsuarioNome,
        seguindo: item.Seguindo,
      });
    });

    if (lReacoes.length < 10) {
      this.loadMoreR = false;
    }
    this.contadorIndexR += lReacoes.length;

    lFollow.forEach((it) => {
      this.arrIFollow.push({ iduser: it.iduser });
    });

    this.arrIFollow.forEach((el) => {
      console.log(this.arrReact.find((x) => x.IdAlunoR == el.iduser));
      this.arrReact.find((x) => x.IdAlunoR == el.iduser).seguindo = true;
    });
  }
  renderizarComentarios(lComentarios: any, resetar: boolean): void {
    if (resetar) {
      this.arrComentarios = [];
    }
    if (lComentarios.length < 10) {
      this.loadMore = false;
    }
    this.contadorIndex += lComentarios.length;
    this.arrCS = [];
    this.arrRespostas = [];

    //funciona porém não concatena
    //this.arrComentarios = lComentarios;

    lComentarios.forEach((el) => {
      this.arrComentarios.push({
        FotoPerfil: el.FotoPerfil,
        Nome: el.Nome,
        UsuarioNome: el.UsuarioNome,
        Comentario: el.Comentario,
        DifDias: el.DifDias,
        Hora: el.Hora,
        Id: el.Id,
        IdComent: el.IdComent,
        Resposta: el.Resposta,
      });
    });
    //fazer um push manual

    this.arrComentarios.forEach((qItem, index) => {
      if (qItem.DifDias > 7) {
        var tempoSem = Math.round(qItem.DifDias / 7);
        if (tempoSem > 56) {
          var tempoY = Math.round(qItem.DifDias / 56);
          this.arrComentarios[index].dt = tempoY + " a";
          //console.log(qItem.DifDias % 7);
        } else {
          this.arrComentarios[index].dt = tempoSem + " sem";
          //console.log(qItem.DifDias / 7);
        }
      } else {
        if (qItem.DifDias == 0) {
          var a = moment(
            qItem.Hora.Hours + ":" + qItem.Hora.Minutes,
            "HH:mm:ss"
          );
          var now = moment();
          console.log(now.diff(a, "hours"));
          if (now.diff(a, "hours") > 0) {
            this.arrComentarios[index].dt = now.diff(a, "hours") + " h";
          } else {
            this.arrComentarios[index].dt = now.diff(a, "minutes") + " m";
          }
        } else {
          this.arrComentarios[index].dt = qItem.DifDias + " d";
        }
      }
    });

    this.arrRespostas = this.arrComentarios;
    this.arrRespostas.reverse();

    //check if has any resp without coment
    this.arrRespostas.forEach((qItem, index) => {
      if (qItem.Resposta) {
        if (
          this.arrComentarios.find((x) => x.Id == qItem.IdComent) == undefined
        ) {
          //
          console.log("sem resposta");
          this.arrCS.push(qItem);
        }
      }
    });

    //this.arrCS.reverse();
  }

  resp(idcomment: any, taguser: any): void {
    this.respCID = idcomment;
    this.respTag = "@" + taguser;
    this.txtmsg = "@" + taguser + " ";
    this.inputEl.nativeElement.focus();
  }

  digitandoComennt(): void {
    console.log(this.txtmsg);
    console.log(this.txtmsg.length);
    if (this.txtmsg.length == 0) {
      this.respCID = 0;
      this.respTag = "";
    }
  }

  reagir(idreacao: any): void {
    if (this.idR != 0) {
      //reagiu, comparar reacoes
      if (this.idR == idreacao) {
        //mesma, remover
        this.callUR();
      } else {
        //nova
        this.callIR(idreacao);
      }
    } else {
      //n reagiu
      this.callIR(idreacao);
    }
  }

  callIR(idreacao: any): void {
    //this.hideCL = false;
    let customParams = {
      //lista: localStorage.getItem('turboCart'),
      email: this.tmaService.hcEmail,
      senha: this.tmaService.hcSenha,
      idPost: this.idPost,
      usuarioPost: this.usuarioPost,
      idReacao: idreacao,
    };
    this.tmaService.addReacao(customParams).subscribe(
      (qRes) => {
        this.hideCL = true;
        console.log(qRes);
        if (qRes["res"] == "done") {
          this.idR = idreacao;
          this.selfR = true;
        } else {
          const erroCriar = this.dialog.open(AlertaSimplesDialog, {
            disableClose: true,
            data: {
              tituloAlerta: "Aviso",
              textoAlerta:
                "Ocorreu um erro ao realizar esta operação Tente novamente",
              iconAlerta: "warning",
            },
          });
        }
      },
      (error) => {
        this.hideCL = true;
        const erroCriar = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: {
            tituloAlerta: "Aviso",
            textoAlerta:
              "Verifique sua conexão com a internet. Tente novamente",
            iconAlerta: "warning",
          },
        });
      }
    );
  }

  callUR(): void {
    //this.hideCL = false;
    let customParams = {
      //lista: localStorage.getItem('turboCart'),
      email: this.tmaService.hcEmail,
      senha: this.tmaService.hcSenha,
      idPost: this.idPost,
      usuarioPost: this.usuarioPost,
    };
    this.tmaService.remReacao(customParams).subscribe(
      (qRes) => {
        this.hideCL = true;
        console.log(qRes);
        if (qRes["res"] == "done") {
          // this.idR = idreacao;
          // this.selfR = true;
          this.idR = 0;
        } else {
          const erroCriar = this.dialog.open(AlertaSimplesDialog, {
            disableClose: true,
            data: {
              tituloAlerta: "Aviso",
              textoAlerta:
                "Ocorreu um erro ao realizar esta operação Tente novamente",
              iconAlerta: "warning",
            },
          });
        }
      },
      (error) => {
        this.hideCL = true;
        const erroCriar = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: {
            tituloAlerta: "Aviso",
            textoAlerta:
              "Verifique sua conexão com a internet. Tente novamente",
            iconAlerta: "warning",
          },
        });
      }
    );
  }

  postMore(nomeusuario: any, idpost: any): void {
    var itsme = false;
    if (this.tmaService.hcNomeUsuario == nomeusuario) itsme = true;

    console.log("clicou");
    const alertaInfoPremium = this.dialog.open(AlertaSocialMoreDialog, {
      width: "270px",
      data: { origem: "post", ms: itsme },
    });
    alertaInfoPremium.afterClosed().subscribe((result) => {
      console.log(result);
      if (result == 1) {
        this.router.navigate(["/me/post/" + nomeusuario + "/" + idpost]);
      }

      if (result == 2) {
        //compartilhar e copiar
        this.sharePost(idpost, nomeusuario);
      }

      if (result == 4) {
        //report
        this.denunciar(idpost, nomeusuario);
      }
      if (result == 5) {
        //excluir
        this.excluir(idpost);
      }
    });
  }

  excluir(idpost: any): void {
    const enviarP = this.dialog.open(AlertaConfirmDialog, {
      //width: '250px',
      disableClose: true,
      data: {
        iconAlerta: "warning",
        tituloAlerta: "Atenção",
        textoAlerta: "Confirma a exclusão dessa publicação? ",
        textoCancel: "Não",
        textoConfirm: "SIM",
      },
    });

    enviarP.afterClosed().subscribe((result) => {
      if (result) {
        //true - do
        this.hideCL = false;
        let customParams = {
          //lista: localStorage.getItem('turboCart'),
          email: this.tmaService.hcEmail,
          senha: this.tmaService.hcSenha,
          idPost: idpost,
        };
        this.tmaService.excluirPost(customParams).subscribe(
          (qRes) => {
            this.hideCL = true;
            console.log(qRes);
            if (qRes["res"] == "done") {
              const exDone = this.dialog.open(AlertaConfirmDialog, {
                //width: '250px',
                disableClose: true,
                data: {
                  iconAlerta: "",
                  tituloAlerta: "Aviso",
                  textoAlerta: "Publicação excluída com sucesso",
                  textoConfirm: "OK",
                },
              });
              exDone.afterClosed().subscribe((result) => {
                this.voltar();
              });
            } else {
              const erroCriar = this.dialog.open(AlertaSimplesDialog, {
                disableClose: true,
                data: {
                  tituloAlerta: "Aviso",
                  textoAlerta:
                    "Ocorreu um erro ao realizar esta operação Tente novamente",
                  iconAlerta: "warning",
                },
              });
            }
          },
          (error) => {
            this.hideCL = true;
            const erroCriar = this.dialog.open(AlertaSimplesDialog, {
              disableClose: true,
              data: {
                tituloAlerta: "Aviso",
                textoAlerta:
                  "Verifique sua conexão com a internet. Tente novamente",
                iconAlerta: "warning",
              },
            });
          }
        );
      }
    });
  }

  sharePost(idpost: any, nickusuario: any) {
    // this.ngNavigatorShareService.share({
    //   title: 'Publicação de ' + nickusuario,
    //   text: 'Confira esse post no Tamas',
    //   url: 'https://tamasapp.com/me/post/' + nickusuario + '/' + idpost
    // }).then((response) => {
    //   console.log(response);
    // })
    //   .catch((error) => {
    //     console.log(error);
    //     //alert("lalalal");
    //     this.copyToClipboard2('https://tamasapp.com/me/' + nickusuario + '/' + idpost);
    //   });
  }

  copyToClipboard2(item) {
    document.addEventListener("copy", (e: ClipboardEvent) => {
      e.clipboardData.setData("text/plain", item);
      e.preventDefault();
      document.removeEventListener("copy", null);
    });
    document.execCommand("copy");
    const erroCriar = this.dialog.open(AlertaSimplesDialog, {
      disableClose: true,
      data: {
        tituloAlerta: "Link do Post",
        textoAlerta: "O link para esse post foi copiado com sucesso!",
        iconAlerta: "",
      },
    });
  }

  denunciar(idpost: any, nickuser: any): any {
    this.hideCL = false;
    let customParams = {
      //lista: localStorage.getItem('turboCart'),
      email: this.tmaService.hcEmail,
      senha: this.tmaService.hcSenha,
      idPost: idpost,
      usuarioPost: nickuser,
    };
    this.tmaService.reportPost(customParams).subscribe(
      (qRes) => {
        this.hideCL = true;
        console.log(qRes);
        if (qRes["res"] == "done") {
          //comentário realizado, trazer os últimos
          console.log(qRes);
          const reportRreal = this.dialog.open(AlertaSimplesDialog, {
            disableClose: true,
            data: {
              tituloAlerta: "Aviso",
              textoAlerta:
                "Sua denúncia foi enviada com sucesso para o setor responsável.",
              iconAlerta: "done",
            },
          });
        } else {
          const erroCriar = this.dialog.open(AlertaSimplesDialog, {
            disableClose: true,
            data: {
              tituloAlerta: "Aviso",
              textoAlerta:
                "Ocorreu um erro ao realizar esta operação Tente novamente",
              iconAlerta: "warning",
            },
          });
        }
      },
      (error) => {
        this.hideCL = true;
        const erroCriar = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: {
            tituloAlerta: "Aviso",
            textoAlerta:
              "Verifique sua conexão com a internet. Tente novamente",
            iconAlerta: "warning",
          },
        });
      }
    );
  }

  followup(tagusuario: any, qIndex: any): void {
    this.hideCL = false;
    let customParams = {
      //lista: localStorage.getItem('turboCart'),
      nomeusuarioTF: tagusuario,
      email: this.tmaService.hcEmail,
      senha: this.tmaService.hcSenha,
    };
    this.tmaService.followUser(customParams).subscribe(
      (qRes) => {
        this.hideCL = true;
        console.log(qRes);
        if (qRes["res"] == "done") {
          this.arrReact[qIndex].seguindo = true;
        } else {
          const erroCriar = this.dialog.open(AlertaSimplesDialog, {
            disableClose: true,
            data: {
              tituloAlerta: "Aviso",
              textoAlerta:
                "Ocorreu um erro ao realizar esta operação Tente novamente",
              iconAlerta: "warning",
            },
          });
        }
      },
      (error) => {
        this.hideCL = true;
        const erroCriar = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: {
            tituloAlerta: "Aviso",
            textoAlerta:
              "Verifique sua conexão com a internet. Tente novamente",
            iconAlerta: "warning",
          },
        });
      }
    );
  }

  followremove(tagusuario: any, qIndex: any): void {
    this.hideCL = false;
    let customParams = {
      //lista: localStorage.getItem('turboCart'),
      nomeusuarioTR: tagusuario,
      email: this.tmaService.hcEmail,
      senha: this.tmaService.hcSenha,
    };
    this.tmaService.unfollowUser(customParams).subscribe(
      (qRes) => {
        this.hideCL = true;
        console.log(qRes);
        if (qRes["res"] == "done") {
          this.arrReact[qIndex].seguindo = false;
        } else {
          const erroCriar = this.dialog.open(AlertaSimplesDialog, {
            disableClose: true,
            data: {
              tituloAlerta: "Aviso",
              textoAlerta:
                "Ocorreu um erro ao realizar esta operação Tente novamente",
              iconAlerta: "warning",
            },
          });
        }
      },
      (error) => {
        this.hideCL = true;
        const erroCriar = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: {
            tituloAlerta: "Aviso",
            textoAlerta:
              "Verifique sua conexão com a internet. Tente novamente",
            iconAlerta: "warning",
          },
        });
      }
    );
  }
  toggleOpacity(): void {
    this.hideAB = !this.hideAB;
    // console.log(this.bRT);
    // this._showRT.next(true);
    // if(this.showRT._isScalar){
    //   this._showRT.next(false);
    // }
    // else{
    //   this._showRT.next(true);
    // }
  }

  scrollNormal(): void {
    console.log("scroll");
    this.posicao.nativeElement.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  }

  onBlur(event) {
    //do nothing
  }

  enviarMsg(): void {
    if (this.txtmsg.replace(this.respTag, "") == " ") {
      const erroCriar = this.dialog.open(AlertaSimplesDialog, {
        disableClose: true,
        data: {
          tituloAlerta: "Erro",
          textoAlerta: "Digite uma mensagem para comentar",
          iconAlerta: "warning",
        },
      });
    } else {
      //definir tamanho mínimo?
      this.hideCL = false;
      var respondendo = false;
      let customParams = {
        //lista: localStorage.getItem('turboCart'),
        email: this.tmaService.hcEmail,
        senha: this.tmaService.hcSenha,
        comentario: this.txtmsg.replace(this.respTag, ""),
        idPost: this.idPost,
        usuarioPost: this.usuarioPost,
        idc: this.respCID,
      };
      this.tmaService.addComentario(customParams).subscribe(
        (qRes) => {
          this.hideCL = true;
          console.log(qRes);
          if (qRes["res"] == "done") {
            //comentário realizado, trazer os últimos
            this.txtmsg = "";
            this.respCID = 0;
            this.respTag = "";
            this.contadorIndex = 0;
            this.carregarComentarios(0);
          } else {
            const erroCriar = this.dialog.open(AlertaSimplesDialog, {
              disableClose: true,
              data: {
                tituloAlerta: "Aviso",
                textoAlerta:
                  "Ocorreu um erro ao realizar esta operação Tente novamente",
                iconAlerta: "warning",
              },
            });
          }
        },
        (error) => {
          this.hideCL = true;
          const erroCriar = this.dialog.open(AlertaSimplesDialog, {
            disableClose: true,
            data: {
              tituloAlerta: "Aviso",
              textoAlerta:
                "Verifique sua conexão com a internet. Tente novamente",
              iconAlerta: "warning",
            },
          });
        }
      );
    }
  }

  carregarComentarios(numIndex: any): void {
    this.hideCL = false;
    let customParams = {
      //lista: localStorage.getItem('turboCart'),
      email: this.tmaService.hcEmail,
      senha: this.tmaService.hcSenha,
      numIndex: numIndex,
      idPost: this.idPost,
      usuarioPost: this.usuarioPost,
    };
    this.tmaService.listarComentarios(customParams).subscribe(
      (qRes) => {
        this.hideCL = true;
        console.log(qRes);
        if (qRes["res"] == "done") {
          if (qRes["arrResultado"].length == 0) {
            //não há mais comentários
            //console.log("sem coments");
            this.loadMore = false;
          } else {
            if (qRes["arrResultado"].length < 10) {
              this.loadMore = false;
            }
            //comentário realizado, trazer os últimos
            if (numIndex == 0) {
              this.renderizarComentarios(qRes["arrResultado"], true);
            } else {
              this.renderizarComentarios(qRes["arrResultado"], false);
            }
          }
        } else {
          const erroCriar = this.dialog.open(AlertaSimplesDialog, {
            disableClose: true,
            data: {
              tituloAlerta: "Aviso",
              textoAlerta:
                "Ocorreu um erro ao realizar esta operação Tente novamente",
              iconAlerta: "warning",
            },
          });
        }
      },
      (error) => {
        this.hideCL = true;
        const erroCriar = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: {
            tituloAlerta: "Aviso",
            textoAlerta:
              "Verifique sua conexão com a internet. Tente novamente",
            iconAlerta: "warning",
          },
        });
      }
    );
  }

  carregarReacoes(numIndex: any): void {
    this.hideCL = false;
    let customParams = {
      //lista: localStorage.getItem('turboCart'),
      email: this.tmaService.hcEmail,
      senha: this.tmaService.hcSenha,
      numIndex: numIndex,
      idPost: this.idPost,
      usuarioPost: this.usuarioPost,
    };
    this.tmaService.listarReacoes(customParams).subscribe(
      (qRes) => {
        this.hideCL = true;
        console.log(qRes);
        if (qRes["res"] == "done") {
          if (qRes["arrResultado"].length == 0) {
            //não há mais comentários
            //console.log("sem coments");
            this.loadMoreR = false;
          } else {
            if (qRes["arrResultado"].length < 10) {
              this.loadMoreR = false;
            }
            //comentário realizado, trazer os últimos
            if (numIndex == 0) {
              this.renderizarReacoes(qRes["arrResultado"], qRes["iFollow"]);
            } else {
              this.renderizarReacoes(qRes["arrResultado"], qRes["iFollow"]);
            }
          }
        } else {
          const erroCriar = this.dialog.open(AlertaSimplesDialog, {
            disableClose: true,
            data: {
              tituloAlerta: "Aviso",
              textoAlerta:
                "Ocorreu um erro ao realizar esta operação Tente novamente",
              iconAlerta: "warning",
            },
          });
        }
      },
      (error) => {
        this.hideCL = true;
        const erroCriar = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: {
            tituloAlerta: "Aviso",
            textoAlerta:
              "Verifique sua conexão com a internet. Tente novamente",
            iconAlerta: "warning",
          },
        });
      }
    );
  }

  goPerfil(nickusuario: any): void {
    this.tmaService.gUrlAnterior = this.router.url;
    this.router.navigate(["/" + nickusuario]);
  }

  voltar(): void {
    // this._location.back();
    if (this.tmaService.gUrlAnterior != "") {
      this.router.navigate([this.tmaService.gUrlAnterior]);
    } else {
      this.router.navigate(["me/feed"]);
    }
  }
}
